<template>
  <div>
    <div class="ticket-info-top team-info-top">
      <img :src="imageSrc(bgImg)" alt="">
      <div class="team-box">
        <p class="test-notice">
          예매 테스트 링크입니다
        </p>
        <div class="btn-div">
          <button class="reservations" @click="callTicketing('ticketing')">티켓예매</button>
          <button class="check" @click="callTicketing('check')">예매확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ticketingFunc } from '@/lib/ticketingModule';

export default {
  name: 'ReservationTest',
  data() {
    return {
      bgImg: 'ticket_info',
    }
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/banner/' + imgSrc + '.png');
    },

    async callTicketing(type) {
      // 로그인 여부 확인
      if (!this.$store.state.login) {
        alert('로그인 후 이용 가능합니다.');
        await this.$router.push({
          name: 'login',
          params: { redirectUrl: '/ticket/reservations' }
        });
        return false;
      }

      const product_code = "26007819";

      if (type === "ticketing") {
        await ticketingFunc({ http: this.$http }, type, product_code);
      } else {
        await ticketingFunc({ http: this.$http }, type);
      }
    }
  }
}
</script>

<style scoped>
.test-notice {
  color: #ffffff;
  font-size: 20px;
}
</style>
